// extracted by mini-css-extract-plugin
module.exports = {"ContactForms":"ContactForms_ContactForms__QeaS8","contacts__requiredText":"ContactForms_contacts__requiredText__3uKwS"};